import { FC } from 'react'
import { flightDate, flightTime } from '../../../utils'
import {
  OrderDetailPurchaseDetails,
  OrderDetailPurchaseDetailsArrival,
  OrderDetailPurchaseDepartureRow,
  OrderDetailPurchaseItem,
  OrderDetailPurchaseSpanBold,
  OrderDetailPurchaseSpanRegular,
  OrderDetailPurchaseTitle,
  OrderDetailPurchaseTitleSeparator,
  OrderDetailPurchaseTitleSeparatorH,
} from '../order.styled'
import { OrderDetailPurchaseProps } from '../order.types'
import { useTranslation } from 'react-i18next'

export const OrderDetailPurchase: FC<OrderDetailPurchaseProps> = ({
  items,
}) => {
  const { t } = useTranslation()

  return (
    <>
      {items.map((item, index) => (
        <OrderDetailPurchaseItem key={index}>
          <OrderDetailPurchaseTitle>
            <OrderDetailPurchaseSpanRegular>
              {t('Departure Flight')}:{' '}
              <OrderDetailPurchaseSpanBold>
                {item.flight_number}
              </OrderDetailPurchaseSpanBold>
            </OrderDetailPurchaseSpanRegular>
            <OrderDetailPurchaseSpanRegular>
              {flightDate(item.departure_datetime)}
            </OrderDetailPurchaseSpanRegular>
            <OrderDetailPurchaseTitleSeparator />
            <OrderDetailPurchaseSpanRegular>
              {flightTime(item.departure_datetime)}
            </OrderDetailPurchaseSpanRegular>
          </OrderDetailPurchaseTitle>
          <OrderDetailPurchaseDetails>
            <OrderDetailPurchaseDepartureRow>
              <OrderDetailPurchaseSpanRegular>
                {t('Departure')} {item.departure_airport}
              </OrderDetailPurchaseSpanRegular>
              <OrderDetailPurchaseTitleSeparatorH />
              <OrderDetailPurchaseSpanRegular className="rtl-left">
                {t('Arrival')}: {item.arrival_airport}
              </OrderDetailPurchaseSpanRegular>
            </OrderDetailPurchaseDepartureRow>
            <OrderDetailPurchaseDetailsArrival>
              <OrderDetailPurchaseSpanRegular>
                {t('Time zone')}: {item.departure_airport_timezone}
              </OrderDetailPurchaseSpanRegular>
              <OrderDetailPurchaseSpanRegular>
                {t('Carrier code')}: {item.carrier_code}
              </OrderDetailPurchaseSpanRegular>
              <OrderDetailPurchaseSpanRegular>
                {t('Fare basis code')}: {item.fare_basis_code}
              </OrderDetailPurchaseSpanRegular>
              <OrderDetailPurchaseSpanRegular>
                {t('Fare class code')}: {item.fare_class_code}
              </OrderDetailPurchaseSpanRegular>
            </OrderDetailPurchaseDetailsArrival>
          </OrderDetailPurchaseDetails>
        </OrderDetailPurchaseItem>
      ))}
    </>
  )
}
